<div [ngStyle]="{'width': 'width' ? width+'px' : '140px'}" [class]="getColorClass()">
    <img *ngIf="iconClass" [className]="iconClass"/>
    <span>{{ content }}</span>
</div>
